
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

@Injectable()
export class CustomReuseStrategy implements RouteReuseStrategy {
  private storedRoutes = new Map<string, DetachedRouteHandle>();
  private readonly ROOT_ROUTE_KEY = '__root__';

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const path = route.routeConfig?.path;
    // Only detach the root route, not cigclaim or other routes
    return path === '';
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    if (route.routeConfig?.path === '') {
      this.storedRoutes.set(this.ROOT_ROUTE_KEY, handle);
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return route.routeConfig?.path === '' && this.storedRoutes.has(this.ROOT_ROUTE_KEY);
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    if (route.routeConfig?.path !== '') {
      return null;
    }
    return this.storedRoutes.get(this.ROOT_ROUTE_KEY) || null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    // Don't reuse route when navigating to cigclaim to avoid state conflicts
    if (future.routeConfig?.path === 'cigclaim') {
      return false;
    }
    return future.routeConfig === current.routeConfig;
  }
}
